import { storeToRefs } from 'pinia';
import { commonApi } from '../apis';
import { useGlobalStore } from '../store';

export const useRecord = () => {
  const globalStore = useGlobalStore();
  const { isAllowProtocol } = storeToRefs(globalStore);
  const commonParams = () => {
    return {
      isAllowProtocol: isAllowProtocol.value || false,
    };
  };

  const createRecordId = async (params: any = {}) => {
    const paramsCopy = {
      ...params,
      ...commonParams(),
    };
    return await commonApi.recorderCreate(paramsCopy);
  };

  const recordDynamics = async (params: any = {}) => {
    const paramsCopy = {
      ...params,
      ...commonParams(),
    };
    return await commonApi.recordDynamics(paramsCopy);
  };

  const recordDuration = async (params: any = {}) => {
    const paramsCopy = {
      ...params,
      ...commonParams(),
    };
    return await commonApi.recordDuration(paramsCopy);
  };

  const trackBuried = async (params: any = {}) => {
    const paramsCopy = {
      ...params,
      ...commonParams(),
    };
    return await commonApi.trackBuried(paramsCopy);
  };

  const recordManagerParam = async (params: any = {}) => {
    return await commonApi.recordManagerParam(params);
  };

  return {
    createRecordId,
    recordDynamics,
    recordManagerParam, // 光大针对经理在微信中需要另外调用接口上报数据
    recordDuration,
    trackBuried,
  };
};
